import React, { ElementType } from 'react';
import { styled } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';
import { Colors } from 'library';
import { RBaseButton } from './RBaseButton';

interface RIconButtonProps {
    icon: SvgIconComponent | ElementType<{ sx?: unknown }>;
    onClick?: (e: React.MouseEvent) => void;
    disabled?: boolean;
    selected?: boolean;
    size?: number;
    iconSize?: number;
    className?: string;
}

export function RIconButton({
    icon: Icon,
    onClick,
    disabled,
    selected,
    size = 36,
    iconSize = 22,
    className,
}: RIconButtonProps) {
    return (
        <Button
            onClick={onClick}
            disabled={disabled}
            selected={selected}
            className={className}
            style={{ width: size, height: size }}
        >
            <Icon sx={{ fontSize: iconSize }} />
        </Button>
    );
}

const Button = styled(RBaseButton)<{ selected?: boolean }>(({ selected }) => ({
    background: selected ? Colors.fill : 'none',
    color: selected ? Colors.darkNavy : Colors.mediumGrey,
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '&:hover': { backgroundColor: selected ? Colors.fill : Colors.faintGrey },
    '&:disabled': { opacity: 0.4, cursor: 'default' },
}));
